import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import styled from "styled-components";
import { Form, Card, Button, Row, Col, Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUtensils,
  faEnvelope,
  faCheckCircle,
  faSearch,
  faPhone,
  faCopy,
  faSquarePhoneFlip,
} from "@fortawesome/free-solid-svg-icons";
import {
  getManagers,
  registerManager,
  deleteManager,
  updateManager,
} from "../actions/managersActions";
import { fetchRestaurantList } from "../actions/restaurantActions";
import { verify_username } from "../actions/userActions";
import Messages from "../components/Messages";
import WaitCheckMark from "../components/WaitCheckMark";
import { getDialCode, getCountryCode } from "../components/CountryCode";
import SwitchOnAndOff from "../components/SwitchOnAndOff";
import DatePicker from "react-datepicker";
import { pt } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";
import {
  ContainerBox,
  Header,
  Body,
  OrangeButton,
  Title,
  Container,
  CardHeader,
  CardHeaderTitle,
  StyledInput,
  ModernButton,
  StyledLabel,
} from "../components/DefaultImports";

import "react-phone-input-2/lib/style.css"; // Import the default CSS for react-phone-input-2
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css"; // Import the Bootstrap CSS for additional styling
import { ConfirmationModal } from "../components/ConfirmationModal";
import { CustomModal } from "../components/CustomModal";
import PhoneField from "../components/PhoneField";

const ITEMS_PER_PAGE = 10;
const BOTTOM_PADDING = 40;

function ManagersCreationScreen() {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);

  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [managerToDeleteID, setManagerToDeleteID] = useState("");

  const [getEmail, setGetEmail] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [permission, setPermission] = useState("");
  const [restaurant_choices, setRestaurant_choices] = useState([]);
  const [manager_id, setManager_id] = useState("");

  const [whatsapp_notification_token, setWhatsapp_notification_token] =
    useState("");
  const [getWhatsappNotifications, setGetWhatsappNotifications] = useState("");

  const [readReservations, setReadReservations] = useState(false);
  const [editReservations, setEditReservations] = useState(false);
  const [changeStatus, setChangeStatus] = useState(false);
  const [editRestaurantSettings, setEditRestaurantSettings] = useState(false);
  const [editClosedDays, setEditClosedDays] = useState(false);

  const [countryCode, setCountryCode] = useState("us");
  const [countryCodeNumber, setCountryCodeNumber] = useState("351");
  const [phone, setPhone] = useState("");
  const [phoneWithoutCountryCode, setPhoneWithoutCountryCode] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const [isWaiting, setIsWaiting] = useState(false);
  const [update_or_create, setUpdate_or_create] = useState("");

  const [isSuspending, setIsSuspending] = useState(false);
  const [dateToSuspend, setDateToSuspend] = useState("");
  const [showSuspendModal, setShowSuspendModal] = useState(false);
  const [managerToSuspend, setManagerToSuspend] = useState(null);
  const [isPhoneValid, setIsPhoneValid] = useState(false);

  useEffect(() => {
    if (countryCodeNumber === "") {
      const detectedCountryCode = detectCountryCode();
      setCountryCode(detectedCountryCode);
      setCountryCodeNumber(getDialCode(detectedCountryCode));
    } else {
      setCountryCode(getCountryCode(countryCodeNumber));
    }
  }, [countryCodeNumber]);

  const detectCountryCode = () => {
    const userCountryCode = navigator.language.split("-")[1];
    const formattedCountryCode = userCountryCode
      ? userCountryCode.toLowerCase()
      : "us";
    // Add more specific checks if needed based on the origin or location detection mechanism
    return formattedCountryCode; // Default to 'PT' if the country code is not detected
  };

  useEffect(() => {
    // Check if countryCode and phone are not null or undefined before concatenating
    if (countryCodeNumber && phoneWithoutCountryCode) {
      setPhone(String(countryCodeNumber) + String(phoneWithoutCountryCode));
    }
  }, [phoneWithoutCountryCode, countryCodeNumber]);

  const MAX_CHARACTER_LIMIT = 10;

  const handleInputPhoneChange = (e) => {
    const inputValue = e.target.value;

    if (inputValue.length <= MAX_CHARACTER_LIMIT) {
      setPhoneWithoutCountryCode(inputValue);
    }
  };

  useEffect(() => {
    if (email && email.length > 0) {
      dispatch(verify_username(email));
    }
  }, [email]);

  useEffect(() => {}, [restaurant_choices]);
  useEffect(() => {
    dispatch(getManagers());
  }, [dispatch]);

  const manager_info = useSelector((state) => state.crudManager);
  const { managersInfo } = manager_info;

  const restaurantList = useSelector((state) => state.restaurantList);
  const { restaurants, isLoading, error } = restaurantList;

  const verify_username_existance = useSelector((state) => state.userRegister);
  const { username_exists } = verify_username_existance;
  const listRef = useRef(null);
  const [listHeight, setListHeight] = useState(0);

  useLayoutEffect(() => {
    if (!listRef.current) return;

    const updateHeight = () => {
      if (!listRef.current) return;
      const top = listRef.current.getBoundingClientRect().top;
      const height = window.innerHeight - top - BOTTOM_PADDING;
      setListHeight(Math.max(0, height));
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    window.addEventListener("orientationchange", updateHeight);

    const ro = new ResizeObserver(() => updateHeight());
    ro.observe(document.body);

    const raf = requestAnimationFrame(updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
      window.removeEventListener("orientationchange", updateHeight);
      ro.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [
    managersInfo,
    searchResults,
    showModal,
    showRemoveModal,
    showSuspendModal,
  ]);

  useEffect(() => {
    if (managersInfo) {
      const results = managersInfo.filter(
        (manager) =>
          manager.user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          manager.user.email.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setSearchResults(results);
    }
  }, [searchTerm, managersInfo]);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handleClose = () => setShowModal(false);

  const handleShow = (
    param,
    permissions,
    allowed_restaurants,
    name,
    email,
    id,
    getEmails,
    the_country_code,
    the_phone_number,
    read_reservations,
    edit_reservations,
    change_status,
    edit_restaurant_settings,
    edit_closed_days,
    suspensionDate,
  ) => {
    setShowModal(true);
    setUpdate_or_create(param);
    if (param === "update") {
      setCountryCodeNumber(the_country_code);
      setPhone(the_phone_number);
      setPhoneWithoutCountryCode(the_phone_number);
      setEmail(email);
      setName(name);
      setRestaurant_choices(getRestaurantsByIds(allowed_restaurants));
      setPermission(permissions);
      setManager_id(id);
      setGetEmail(getEmails);
      // Set new permission fields for 'update'
      setReadReservations(read_reservations);
      setEditReservations(edit_reservations);
      setChangeStatus(change_status);
      setEditRestaurantSettings(edit_restaurant_settings);
      setEditClosedDays(edit_closed_days);
      setDateToSuspend(suspensionDate);
      // Parse suspension date and compare it with today's date
      const suspension = new Date(suspensionDate);
      const today = new Date();
      if (suspension < today) {
        setIsSuspending(false);
      } else {
        setIsSuspending(true);
      }
    } else {
      setEmail("");
      setName("");
      setRestaurant_choices([]);
      setPermission("");
      setPhone("");
      setCountryCodeNumber("");
      setWhatsapp_notification_token("");
      setDateToSuspend("");
      setIsSuspending(false);
      setGetWhatsappNotifications(false);
      setGetEmail(false);
      // Reset new permission fields for 'create'
      setReadReservations(false);
      setEditReservations(false);
      setChangeStatus(false);
      setEditRestaurantSettings(false);
      setEditClosedDays(false);
    }
  };

  const handleUpdateManager = () => {
    let ids = restaurant_choices.map((restaurant) => restaurant.id);
    if (restaurant_choices.length > 0) {
      let phoneWithoutCountryCoda;
      if (phone.length > 5) {
        const countryCodeLength = countryCodeNumber.length;
        let phoneNumber = phone;

        // Remove leading plus if it exists
        if (phoneNumber[0] === "+") {
          phoneNumber = phoneNumber.slice(1);
        }

        // Remove leading country code number
        phoneWithoutCountryCoda = phoneNumber.slice(countryCodeLength);
      }
      setIsWaiting(true);
      setShowModal(false);

      dispatch(
        updateManager(
          permission,
          ids,
          false,
          manager_id,
          getEmail,
          countryCodeNumber,
          phoneWithoutCountryCoda,
          readReservations,
          editReservations,
          changeStatus,
          editRestaurantSettings,
          editClosedDays,
          dateToSuspend,
        ),
      );
      setTimeout(() => {
        setIsWaiting(false);
      }, 1500);
    }
  };

  const handleCreateManager = () => {
    let ids = restaurant_choices.map((restaurant) => restaurant.id);

    // Ensure required fields are valid before dispatching the action
    if (!username_exists && restaurant_choices.length > 0) {
      setIsWaiting(true);
      setShowModal(false);

      // Dispatch the action with the new permission fields included
      dispatch(
        registerManager(
          name,
          email,
          permission,
          ids,
          getEmail,
          countryCodeNumber,
          phone,
          whatsapp_notification_token, // Ensure this is handled
          getWhatsappNotifications, // Ensure this is handled
          readReservations, // New permission field
          editReservations, // New permission field
          changeStatus, // New permission field
          editRestaurantSettings, // New permission field
          editClosedDays, // New permission field
        ),
      );

      // Simulate waiting for the operation to complete
      setTimeout(() => {
        setIsWaiting(false);
      }, 1500);
    }
  };

  const paginatedResults = searchResults.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE,
  );
  const hasPrevPage = currentPage > 1;
  const hasNextPage =
    currentPage < Math.ceil(searchResults.length / ITEMS_PER_PAGE);

  const handleRestaurantSelection = (e, restaurant) => {
    if (e.target.checked) {
      setRestaurant_choices((prevChoices) => [...prevChoices, restaurant]);
    } else {
      setRestaurant_choices((prevChoices) =>
        prevChoices.filter((choice) => choice !== restaurant),
      );
    }
  };

  const getRestaurantsByIds = (allowed_restaurants) => {
    if (Array.isArray(allowed_restaurants) && Array.isArray(restaurants)) {
      return restaurants.filter((restaurant) =>
        allowed_restaurants.includes(restaurant.id),
      );
    }
    // Return an empty array if the conditions are not met
    return [];
  };

  const handleDelete = () => {
    dispatch(deleteManager(managerToDeleteID));
    setShowRemoveModal(false);
  };

  const handleShowDeleteModal = (id) => {
    setShowRemoveModal(true);
    setManagerToDeleteID(id);
  };

  useEffect(() => {
    if (isSuspending === false) {
      setDateToSuspend(null);
    }
  }, [isSuspending]);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleSuspendManager = () => {
    if (managerToSuspend && dateToSuspend) {
      setIsWaiting(true);
      setShowSuspendModal(false);

      dispatch(
        updateManager(
          managerToSuspend.permissions,
          managerToSuspend.allowed_restaurants,
          false,
          managerToSuspend.user.id,
          managerToSuspend.getEmails,
          managerToSuspend.country_code,
          managerToSuspend.phone_number,
          managerToSuspend.read_reservations,
          managerToSuspend.edit_reservations,
          managerToSuspend.change_status,
          managerToSuspend.edit_restaurant_settings,
          managerToSuspend.edit_closed_days,
          dateToSuspend,
        ),
      );

      setTimeout(() => {
        setIsWaiting(false);
      }, 1500);
    }
  };

  const handleUnsuspendManager = () => {
    if (managerToSuspend) {
      setIsWaiting(true);
      setShowSuspendModal(false);

      dispatch(
        updateManager(
          managerToSuspend.permissions,
          managerToSuspend.allowed_restaurants,
          false,
          managerToSuspend.user.id,
          managerToSuspend.getEmails,
          managerToSuspend.country_code,
          managerToSuspend.phone_number,
          managerToSuspend.read_reservations,
          managerToSuspend.edit_reservations,
          managerToSuspend.change_status,
          managerToSuspend.edit_restaurant_settings,
          managerToSuspend.edit_closed_days,
          null, // <- remove a suspensão
        ),
      );

      setTimeout(() => {
        setIsWaiting(false);
      }, 1500);
    }
  };

  return (
    <Container>
      <CardHeader>
        <CardHeaderTitle>Membros</CardHeaderTitle>
      </CardHeader>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "10px",
        }}
      >
        <ModernButton color="#9FBBC1 " onClick={() => handleShow("create")}>
          + Adicionar membro
        </ModernButton>
      </div>

      <ConfirmationModal
        show={showRemoveModal}
        onHide={() => setShowRemoveModal(false)}
        onConfirm={handleDelete}
        onCancel={() => setShowRemoveModal(false)}
        title="Remover membro"
        body="Tem a certeza que pretende remover este membro da equipa?"
        confirmLabel="Remover"
        cancelLabel="Não remover"
        confirmColor="#EE754C"
        cancelColor="#99b0ad"
      />
      <CustomModal
        show={showModal}
        onHide={handleClose}
        title={
          update_or_create === "create" ? "Adicionar membro" : "Editar membro"
        }
        footer={
          <>
            <ModernButton color="#99b0ad" onClick={handleClose}>
              Cancelar
            </ModernButton>
            {update_or_create === "create" ? (
              <ModernButton color="#EE754C" onClick={handleCreateManager}>
                Adicionar membro
              </ModernButton>
            ) : (
              <ModernButton color="#EE754C" onClick={handleUpdateManager}>
                Gravar alterações
              </ModernButton>
            )}
          </>
        }
      >
        <Row>
          <Form>
            <Form.Group className="mb-3" controlId="formName">
              <Nome>Nome</Nome>
              <StyledInput
                required
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                disabled={update_or_create === "update"}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
              <StyledLabel>E-mail</StyledLabel>
              <StyledInput
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={update_or_create === "update"}
              />
              {username_exists &&
                email.length > 0 &&
                update_or_create === "create" && (
                  <Messages variant="danger">
                    {" "}
                    Este email já se encontra em uso.
                  </Messages>
                )}
            </Form.Group>
            <Form.Group>
              <div style={{ position: "relative" }}>
                <StyledLabel>Número de telemóvel</StyledLabel>
                <PhoneField
                  countryCodeNumber={countryCodeNumber}
                  setCountryCodeNumber={setCountryCodeNumber}
                  phoneWithoutCountryCode={phoneWithoutCountryCode}
                  setPhoneWithoutCountryCode={setPhoneWithoutCountryCode}
                  isPhoneValid={isPhoneValid}
                  setIsPhoneValid={setIsPhoneValid}
                  initialFullPhone={phone}
                />
              </div>
            </Form.Group>
            {/* <Form.Group className="mb-3" controlId="formPermission">
                    <Form.Label>Permissões</Form.Label>
                    <Form.Select
                        aria-label="Default select example"
                        value={permission}
                        onChange={(e) => setPermission(e.target.value)}
                    >
                        <option value="">Selecionar permissão</option>
                        <option value="full_access">Acesso completo</option>
                        <option value="accept_cancel_reservations">Aceitar/Cancelar reservas</option>
                        <option value="attended_or_not_attended">Confirmar chegadas</option>
                    </Form.Select>
                </Form.Group>   */}
            <div>
              <StyledLabel>Permissões</StyledLabel>
              <Row className="mb-3">
                <Col xs={12} md={6}>
                  <OrangeCheckbox
                    type="checkbox"
                    id="readReservations"
                    label="Visualizar reservas"
                    checked={readReservations}
                    onChange={(e) => setReadReservations(e.target.checked)}
                    className="custom-orange-checkbox mb-2"
                  />
                  <OrangeCheckbox
                    type="checkbox"
                    id="editReservations"
                    label="Editar reservas"
                    checked={editReservations}
                    onChange={(e) => setEditReservations(e.target.checked)}
                    className="custom-orange-checkbox mb-2"
                  />
                  <OrangeCheckbox
                    type="checkbox"
                    id="changeStatus"
                    label="Alterar estado das reservas"
                    checked={changeStatus}
                    onChange={(e) => setChangeStatus(e.target.checked)}
                    className="custom-orange-checkbox mb-2"
                  />
                </Col>

                <Col xs={12} md={6}>
                  <OrangeCheckbox
                    type="checkbox"
                    id="editRestaurantSettings"
                    label="Editar definições do restaurante"
                    checked={editRestaurantSettings}
                    onChange={(e) =>
                      setEditRestaurantSettings(e.target.checked)
                    }
                    className="custom-orange-checkbox mb-2"
                  />
                  <OrangeCheckbox
                    type="checkbox"
                    id="editClosedDays"
                    label="Editar horários"
                    checked={editClosedDays}
                    onChange={(e) => setEditClosedDays(e.target.checked)}
                    className="custom-orange-checkbox mb-2"
                  />
                </Col>
              </Row>
            </div>

            <Form.Group controlId="restaurants">
              <StyledLabel>Restaurantes de que faz parte</StyledLabel>
              <ScrollableRestaurantList>
                {restaurants?.map((restaurant, index) => {
                  const isSelected = restaurant_choices.includes(restaurant);
                  return (
                    <RestaurantTag
                      key={index}
                      selected={isSelected}
                      onClick={() => {
                        const fakeEvent = {
                          target: { checked: !isSelected },
                        };
                        handleRestaurantSelection(fakeEvent, restaurant);
                      }}
                    >
                      {restaurant.restaurant_name} | {restaurant.adress}
                    </RestaurantTag>
                  );
                })}
              </ScrollableRestaurantList>
            </Form.Group>

            <Form.Group className="mt-4">
              <OrangeCheckbox
                type="checkbox"
                id="getEmailCheck"
                label="Enviar notificações por e-mail a este membro sobre as reservas."
                checked={getEmail}
                onChange={() => setGetEmail(!getEmail)}
              />
            </Form.Group>
          </Form>
        </Row>
      </CustomModal>
      <CustomModal
        show={showSuspendModal}
        onHide={() => setShowSuspendModal(false)}
        title="Suspender membro"
        footer={
          <>
            {managerToSuspend?.suspend_account_date &&
              new Date(managerToSuspend.suspend_account_date) >= new Date() && (
                <ModernButton color="#9FBBC1" onClick={handleUnsuspendManager}>
                  Remover suspensão
                </ModernButton>
              )}

            <ModernButton
              color="#99b0ad"
              onClick={() => setShowSuspendModal(false)}
            >
              Cancelar
            </ModernButton>

            <ModernButton
              color="#EE754C"
              onClick={handleSuspendManager}
              disabled={!dateToSuspend}
            >
              Confirmar suspensão
            </ModernButton>
          </>
        }
      >
        {managerToSuspend && (
          <>
            <p>
              Define uma data-limite para a suspensão de{" "}
              <strong>{managerToSuspend.user.name}</strong>.
            </p>

            {managerToSuspend.suspend_account_date &&
              new Date(managerToSuspend.suspend_account_date) >= new Date() && (
                <p style={{ color: "#ee754c", fontWeight: 500 }}>
                  Este membro está atualmente suspenso até:{" "}
                  <strong>
                    {new Date(
                      managerToSuspend.suspend_account_date,
                    ).toLocaleDateString()}
                  </strong>
                </p>
              )}

            <StyledDatePickerWrapper>
              <DatePicker
                selected={dateToSuspend ? new Date(dateToSuspend) : null}
                onChange={(date) => setDateToSuspend(formatDate(date))}
                dateFormat="yyyy-MM-dd"
                placeholderText="Selecionar data"
                inline
                minDate={new Date()}
                locale={pt}
              />
            </StyledDatePickerWrapper>

            <hr style={{ margin: "20px 0", borderTop: "1px dashed #ccc" }} />

            <p style={{ fontSize: "14px", color: "#666" }}>
              A suspensão impede que este membro tenha acesso ao sistema até a
              data indicada.
            </p>
          </>
        )}
      </CustomModal>

      {isWaiting && <WaitCheckMark />}

      {searchResults.length > 0 && (
        <div style={{ textAlign: "center", marginBottom: "10px" }}>
          <FixedPagination>
            <PageSide>
              {hasPrevPage ? (
                <PageButton onClick={handlePrevPage}>← Anterior</PageButton>
              ) : (
                <PagePlaceholder />
              )}
            </PageSide>

            <PageCenter>
              <PageNumber>{currentPage}</PageNumber>
            </PageCenter>

            <PageSide>
              {hasNextPage ? (
                <PageButton onClick={handleNextPage}>Próxima →</PageButton>
              ) : (
                <PagePlaceholder />
              )}
            </PageSide>
          </FixedPagination>
        </div>
      )}
      <MemberListWrapper ref={listRef} height={listHeight}>
        {paginatedResults.length > 0 ? (
          paginatedResults.map((manager) => (
            <ClientCard key={manager.id}>
              <Row>
                <Col
                  md={5}
                  xs={12}
                  className="d-flex align-items-center gap-2 mb-2"
                >
                  <strong>
                    {manager.user.name}
                    {manager.suspend_account_date &&
                      new Date(manager.suspend_account_date) >= new Date() && (
                        <span
                          style={{
                            color: "red",
                            marginLeft: "8px",
                            fontSize: "0.9em",
                          }}
                        >
                          (Suspenso)
                        </span>
                      )}
                  </strong>
                </Col>
                <Col
                  md={4}
                  xs={12}
                  className="d-flex align-items-center gap-2 text-muted mb-2"
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                  {manager.user.email}
                </Col>
                <Col
                  md={3}
                  xs={12}
                  className="d-flex justify-content-md-end gap-2"
                >
                  <ModernButton
                    color="#c9a23f"
                    onClick={() => {
                      setManagerToSuspend(manager);
                      setDateToSuspend(manager.suspend_account_date || "");
                      setShowSuspendModal(true);
                    }}
                  >
                    Suspender
                  </ModernButton>
                  <ModernButton
                    color="#EE754C"
                    onClick={() =>
                      handleShow(
                        "update",
                        manager.permissions,
                        manager.allowed_restaurants,
                        manager.user.name,
                        manager.user.email,
                        manager.user.id,
                        manager.getEmails,
                        manager.country_code,
                        manager.phone_number,
                        manager.read_reservations,
                        manager.edit_reservations,
                        manager.change_status,
                        manager.edit_restaurant_settings,
                        manager.edit_closed_days,
                        manager.suspend_account_date,
                      )
                    }
                  >
                    Editar
                  </ModernButton>
                  <ModernButton
                    color="#99b0ad"
                    onClick={() => handleShowDeleteModal(manager.user.id)}
                  >
                    Remover
                  </ModernButton>
                </Col>
              </Row>
            </ClientCard>
          ))
        ) : (
          <p className="text-center mt-4">Nenhum membro encontrado.</p>
        )}
      </MemberListWrapper>
    </Container>
  );
}

export default ManagersCreationScreen;

export const Nome = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #99b0ad;
  width: 100%;
  text-align: left;
  margin-bottom: 1px;
  margin-top: 5px;
`;

const MemberListWrapper = styled.div`
  height: ${(props) => props.height || 400}px;
  overflow-y: auto;
  padding-right: 8px;

  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`;

const StyledDatePickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 300px;
  transform: scale(0.9);
  transform-origin: top center;

  .react-datepicker {
    font-size: 16px;
    height: 370px;
    border: none;
    border-radius: 20px;
    box-shadow: none;
    padding: 10px 0;
    background-color: transparent;
  }

  .react-datepicker__header {
    background-color: transparent;
    border-bottom: 1px solid #e0e0e0;
    padding-top: 20px;
  }

  .react-datepicker__current-month {
    font-size: 20px;
    font-weight: 600;
    color: #99b0ad;
    text-align: center;
    margin-bottom: 10px;
  }

  .react-datepicker__day-names {
    margin-top: 10px;
  }

  .react-datepicker__day-name {
    color: #888;
    font-weight: 500;
    font-size: 14px;
  }

  .react-datepicker__day {
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-weight: 500;
    font-size: 14px;
    margin: 2px;
    border-radius: 10px;
    position: relative;
  }

  .react-datepicker__day--selected {
    background-color: #ee754c !important;
    color: white !important;
    border-radius: 10px;
  }

  .react-datepicker__day--keyboard-selected {
    background-color: #d4d4d4;
    color: black;
  }

  .react-datepicker__day:hover {
    background-color: #f79574 !important;
    opacity: 1 !important;
    transform: none !important;
    box-shadow: none !important;
    color: white !important;
  }

  .react-datepicker__day--selected:hover {
    background-color: #ee561b !important;
  }

  .react-datepicker__navigation--previous,
  .react-datepicker__navigation--next {
    background-color: white;
    border: none;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    color: black;
    width: 36px;
    height: 36px;
    position: absolute;
    top: 2%;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    z-index: 2;
    transition: all 0.2s ease;
  }

  .react-datepicker__navigation--previous {
    left: 5px;
    padding-right: 6px;
  }

  .react-datepicker__navigation--next {
    right: 5px;
    padding-left: 6px;
  }

  .react-datepicker__navigation--previous:hover,
  .react-datepicker__navigation--next:hover {
    background-color: #f0f0f0;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
`;

const InputOverlay = styled.input`
  position: absolute;
  top: 33px;
  font-size: 16px;
  left: 105px;
  height: 36px;
  border: none;
  border-radius: 0 3px 0 0;
  background: none;
  outline: none;
  background-color: none;
  padding-bottom: 4px;
`;

const StyledPhoneInput = styled(PhoneInput)`
  .form-control {
    max-width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  }
`;

const OrangeCheckbox = styled(Form.Check)`
  .form-check-input {
    cursor: pointer;
    border-color: #ccc;
  }

  .form-check-input:checked {
    background-color: #ee754c;
    border-color: #ee754c;
  }

  .form-check-input:focus {
    box-shadow: 0 0 0 0.2rem rgba(238, 117, 76, 0.25);
  }
`;

const RestaurantTag = styled.div`
  display: inline-block;
  padding: 8px 12px;
  margin: 6px;
  border-radius: 20px;
  border: 2px solid #ee754c;
  background-color: ${(props) => (props.selected ? "#EE754C" : "white")};
  color: ${(props) => (props.selected ? "white" : "#EE754C")};
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.selected ? "#d8653d" : "#f9e5dd")};
  }
`;
const ScrollableRestaurantList = styled.div`
  max-height: 160px;
  overflow-y: auto;
  padding-right: 4px;
  margin-top: 5px;

  /* Scrollbar estilo discreto */
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`;

const ClientCard = styled(Card)`
  background: white;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  &:hover {
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.07);
  }
`;

const FixedPagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
`;

const PageSide = styled.div`
  display: flex;
  justify-content: center;
  min-width: 120px;
`;

const PageCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PageButton = styled.div`
  background-color: #f2f2f2;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;

  &:hover {
    background-color: #e0e0e0;
  }
`;

const PageNumber = styled.div`
  background-color: #ee754c;
  color: white;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 14px;
  text-align: center;
  min-width: 40px;
`;

const PagePlaceholder = styled.div`
  visibility: hidden;
  min-width: 90px;
`;
